<modal-placeholder>
  <div class="interstitial__container">
    <div class="interstitial__text-container mx-auto">
      <div class="interstitial__title text-start">
        <h3>This page is intended for US healthcare professionals.</h3>
      </div>
      <div class="interstitial__text">
        <p>Are you a US healthcare professional?</p>
      </div>
    </div>
    <div class="interstitial__buttons d-flex flex-column flex-lg-row justify-content-center gap-3">
      <div
        class="interstitial__back d-flex justify-content-center align-items-center gap-2 btn btn-orquid"
        (click)="continue(url)"
      >
        <span>Yes, continue</span>
        <span>
          <svg
            width="19"
            height="15"
            viewBox="0 0 19 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M18.2142 8.07106C18.6048 7.68054 18.6048 7.04737 18.2142 6.65685L11.8503 0.292885C11.4598 -0.0976396 10.8266 -0.0976396 10.4361 0.292885C10.0455 0.683409 10.0455 1.31657 10.4361 1.7071L16.0929 7.36395L10.4361 13.0208C10.0455 13.4113 10.0455 14.0445 10.4361 14.435C10.8266 14.8255 11.4598 14.8255 11.8503 14.435L18.2142 8.07106ZM0 7.36395L0 8.36395H17.5071V7.36395V6.36395H0L0 7.36395Z"
              fill="white"
            />
          </svg>
        </span>
      </div>
      <div
        class="interstitial__continue d-flex justify-content-center align-items-center gap-2 btn btn-orquid-border"
        (click)="close()"
      >
        <span>No, go to patient home page</span>
        <span>
          <span>
            <svg
              width="19"
              height="15"
              viewBox="0 0 19 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18.2142 8.07106C18.6048 7.68054 18.6048 7.04737 18.2142 6.65685L11.8503 0.292885C11.4598 -0.0976396 10.8266 -0.0976396 10.4361 0.292885C10.0455 0.683409 10.0455 1.31657 10.4361 1.7071L16.0929 7.36395L10.4361 13.0208C10.0455 13.4113 10.0455 14.0445 10.4361 14.435C10.8266 14.8255 11.4598 14.8255 11.8503 14.435L18.2142 8.07106ZM0 7.36395L0 8.36395H17.5071V7.36395V6.36395H0L0 7.36395Z"
                fill="#9657D6"
              />
            </svg>
          </span>
        </span>
      </div>
    </div>
  </div>
</modal-placeholder>
